module.exports = __webpack_public_path__ + "img/house.7c9fec1a.png";